import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { SpendMoney } from "../../types"
import { useApi } from "utils"
import moment from "moment"

type UseGetOpBalance = {
  coa_id: number
  onSuccess?: (data: SpendMoney) => void
}

type Response = {
  payload: SpendMoney
}

export function useGetOpBalance({
  coa_id,
  onSuccess
}: UseGetOpBalance) {
  const api = useApi()
  const [data, setData] = useState<SpendMoney>()

  const fetchData = () => {
    if (!coa_id) return

    api.post("/spendmoney/balance", {
      coa_id: coa_id,
      tglsaldo: moment().format("YYYY-MM-DD")
    })
    .then((res: SuccessFetch<Response>) => {
      const fetchedData = res.data.payload
      setData(fetchedData)
      onSuccess?.(fetchedData)
    })
    .catch(() => setData(undefined))
    .finally(() => {

    })
  }


  useEffect(() => {
    fetchData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coa_id])

  return { data }
}
